
<template>
  <div class="content_box">
    <div class="contentPadding42" id="ManageTable">
      <div class="headTitle">
        <img src="@/assets/imgs/icon/icon_headIcon.png" alt />
        角色管理
      </div>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="角色名称" style="margin-right: 30px">
          <el-input
            v-model.trim="searchObj.name"
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色编码" style="margin-right: 30px">
          <el-input
            v-model.trim="searchObj.code"
            placeholder="请输入角色编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="searchObj.state" placeholder="请选择状态">
            <el-option label="不限" value></el-option>
            <el-option label="启用" value="0"></el-option>
            <el-option label="禁用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSearch"
            class="bg5584FF formBotton"
            style="margin-left: 40px"
            >查询</el-button
          >
          <el-button type="info" @click="onReset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <hr class="hr" />
      <el-button type="primary" size="small" class="bg5584FF" @click="addNew">
        <i class="el-icon-plus"></i> 新增角色
      </el-button>
      <div style="height: 20px"></div>
      <el-table
        :data="roleList"
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        v-loading="loading"
      >
        <el-table-column align="center" prop="name" label="角色名称">
          <template slot-scope="scope">
            <span @click="detail(scope.row)" class="canClick">{{
              scope.row.name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="code"
          label="角色编号"
        ></el-table-column>
        <el-table-column align="center" prop="state" label="状态">
          <template slot-scope="scope">{{
            scope.row.state == 0 ? "启用" : "禁用"
          }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="grade"
          label="顺序"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              size="mini"
              class="MR18 bg5584FF"
              type="primary"
              @click="allotRole(scope.row)"
              :disabled="scope.row.state == 1"
              >分配权限</el-button
            >
            <el-button
              size="mini"
              class="MR18 bg5584FF"
              type="primary"
              @click="editRole(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              class="MR18 bg5584FF"
              type="primary"
              @click="deleteRole(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBox">
        <!-- <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="totalNum"
        ></el-pagination> -->
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total,  prev, pager, next"
          :total="totalNum"
        >
        </el-pagination>
      </div>
      <!-- 分配弹框 -->
      <el-dialog
        title="权限分配"
        :visible.sync="showAllotWindow"
        class="dialog1400 manage"
        :before-close="doCloseAllot"
        :close-on-click-modal="false"
      >
        <div class="content">
          <div class="left">
            <el-tree
              node-key="id"
              ref="alotTree"
              :data="menuTree"
              :props="defaultProps"
              @node-click="handleNodeClick"
              default-expand-all
              show-checkbox
            ></el-tree>
          </div>
          <div class="right">
            <el-table
              :data="roleallotList"
              style="width: 100%"
              :header-cell-style="{ backgroundColor: '#5584FF', color: '#fff' }"
            >
              <el-table-column
                align="center"
                prop="name"
                label="功能名称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="shortName"
                label="功能显示简称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="code"
                label="代码"
              ></el-table-column>
              <el-table-column align="center" prop="menu" label="是否菜单功能">
                <template slot-scope="scope">{{
                  scope.row.menu == 0 ? "是" : "否"
                }}</template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="superMenuObj"
                label="上级菜单"
              >
                <template slot-scope="scope">{{
                  scope.row.superMenuObj.label
                }}</template>
              </el-table-column>
              <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                  <el-radio
                    v-model="scope.row.state"
                    :label="0"
                    v-if="scope.row.state == 0"
                    disabled
                    >启用</el-radio
                  >
                  <el-radio v-model="scope.row.state" :label="1" v-else disabled
                    >停用</el-radio
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pageBox">
              <!-- <el-pagination
                background
                @current-change="handleCurrentChangeMenu"
                :current-page.sync="currentPageMenu"
                :page-size="10"
                layout="total,prev, pager, next"
                :total="menuNum"
              ></el-pagination> -->
              <el-pagination
                @current-change="handleCurrentChangeMenu"
                :current-page="currentPageMenu"
                :page-size="10"
                layout="total,  prev, pager, next"
                :total="menuNum"
              >
              </el-pagination>
            </div>
            <div class="btnBox">
              <el-button
                type="primary"
                size="mini"
                class="bg5584FF"
                @click="onSaveAllot"
                >保存</el-button
              >
              <el-button type="normal" size="mini" @click="closeAllot"
                >取消</el-button
              >
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 删除弹框 -->
      <el-dialog
        title="删除"
        :visible.sync="showDeleteWindow"
        class="delete"
        :close-on-click-modal="false"
      >
        <p>确认要删除该条数据？此操作不可逆</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureDelete"
            >确定</el-button
          >
          <el-button type="normal" size="mini" @click="showDeleteWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 编辑弹框 -->
      <el-dialog
        title="编辑"
        :visible.sync="showEditWindow"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
        :before-close="doCloseEdit"
      >
        <el-form
          ref="editForm"
          :model="editObj"
          label-width="120px"
          size="small"
          :rules="editRules"
          v-loading="editLoading"
        >
          <el-form-item label="角色名称：" prop="name">
            <el-input v-model.trim="editObj.name"></el-input>
          </el-form-item>
          <el-form-item label="角色编号：" prop="code">
            <el-input v-model.trim="editObj.code" disabled></el-input>
          </el-form-item>
          <el-form-item label="角色描述：" prop="desc">
            <el-input type="textarea" v-model.trim="editObj.desc"></el-input>
          </el-form-item>
          <el-form-item label="角色状态：" prop="state">
            <el-radio-group v-model="editObj.state">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="显示顺序：" prop="grade">
            <el-input v-model.trim.number="editObj.grade"></el-input>
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureEdit"
            >保存</el-button
          >
          <el-button type="normal" size="mini" @click="closeEdit"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 新建弹框 -->
      <el-dialog
        title="新增角色"
        :visible.sync="showAddWindow"
        class="dialog770 titleChange"
        :before-close="doCloseAdd"
        :close-on-click-modal="false"
      >
        <el-form
          ref="addForm"
          :model="addObj"
          label-width="120px"
          size="small"
          :rules="addRules"
          v-loading="addLoading"
        >
          <el-form-item label="角色名称：" prop="name">
            <el-input v-model.trim="addObj.name"></el-input>
          </el-form-item>
          <el-form-item label="角色编号：" prop="code">
            <el-input v-model.trim="addObj.code"></el-input>
          </el-form-item>
          <el-form-item label="角色描述：" prop="desc">
            <el-input type="textarea" v-model.trim="addObj.desc"></el-input>
          </el-form-item>
          <el-form-item label="角色状态：" prop="state">
            <el-radio-group v-model="addObj.state">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="显示顺序：" prop="grade">
            <el-input v-model.trim.number="addObj.grade"></el-input>
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureAdd"
            >新增</el-button
          >
          <el-button type="normal" size="mini" @click="closeAdd"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 查看弹框 -->
      <el-dialog
        title="查看"
        :visible.sync="showCheckWindow"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
      >
        <el-form
          ref="checkForm"
          :model="checkObj"
          label-width="120px"
          size="small"
        >
          <el-form-item label="角色名称：">
            <el-input v-model="checkObj.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="角色编号：">
            <el-input v-model="checkObj.code" disabled></el-input>
          </el-form-item>
          <el-form-item label="角色描述：">
            <el-input
              type="textarea"
              v-model="checkObj.desc"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="角色状态：">
            <el-radio-group v-model="checkObj.state" disabled>
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="显示顺序：">
            <el-input v-model="checkObj.grade" disabled></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (!Number.isInteger(+value) || +value < 0) {
        callback(new Error("请输入正整数值"));
      } else {
        callback();
      }
    };
    var checkRoleName = (rule, value, callback) => {
      this.$axios
        .get(`/system/role/searchRoleIsExistedByName/${value}`)
        .then((res) => {
          if (res.data == 0) {
            callback();
          } else {
            callback(new Error("角色名已存在"));
          }
        });
    };
    var checkRoleCode = (rule, value, callback) => {
      this.$axios
        .get(`/system//role/searchRoleIsExisted/${value}`)
        .then((res) => {
          if (res.data == 0) {
            callback();
          } else {
            callback(new Error("角色编号已存在"));
          }
        });
    };
    return {
      searchObj: {
        name: "",
        code: "",
        state: "",
      },
      roleList: [],
      roleallotList: [],
      menuTree: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      editObj: {
        name: "",
        code: "",
        desc: "",
        state: "",
        grade: "",
        id: "",
      },
      addObj: {
        name: "",
        code: "",
        desc: "",
        state: 0,
        grade: "",
      },
      checkObj: {
        name: "",
        code: "",
        desc: "",
        state: "",
        grade: "",
      },
      currentPage: 1,
      currentPageMenu: 1,
      showAllotWindow: false,
      showDeleteWindow: false,
      showEditWindow: false,
      showAddWindow: false,
      showCheckWindow: false,
      addLoading: false,
      editLoading: false,
      currentRoleId: "",
      totalNum: 0,
      menuNum: 0,
      deleteId: "",
      pageObj: {},
      menuPageObj: {},
      addRules: {
        name: [
          { required: true, message: "请填写角色名称", trigger: "blur" },
          { validator: checkRoleName, trigger: "blur" },
        ],
        code: [
          { required: true, message: "请填写角色编号", trigger: "blur" },
          { validator: checkRoleCode, trigger: "blur" },
        ],
        desc: [{ required: false, message: "请填写角色描述", trigger: "blur" }],
        state: [{ required: true, message: "请选择角色状态", trigger: "blur" }],
        grade: [
          { validator: checkNum, trigger: "blur" },
          { required: true, message: "请输入显示顺序", trigger: "blur" },
        ],
      },
      editRules: {
        name: [{ required: true, message: "请填写角色名称", trigger: "blur" }],
        code: [{ required: true, message: "请填写角色编号", trigger: "blur" }],
        desc: [{ required: false, message: "请填写角色描述", trigger: "blur" }],
        state: [{ required: true, message: "请选择角色状态", trigger: "blur" }],
        grade: [
          { validator: checkNum, trigger: "blur" },
          { required: true, message: "请输入显示顺序", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    onSearch() {
      this.getRoleList({ pageNum: 1, pageSize: 10 }, this.searchObj);
    },
    onReset() {
      this.getRoleList({ pageNum: 1, pageSize: 10 });
      this.searchObj = {
        name: "",
        code: "",
        state: "",
      };
      this.currentPage = 1;
    },
    addNew() {
      this.showAddWindow = true;
    },
    sureAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          this.$axios
            .post("/system/role/insertRoleInfo", this.addObj)
            .then((res) => {
              Message.success("新增成功");
              this.addLoading = false;
              this.showAddWindow = false;
              this.onReset();
              //console.log("新增成功", res);
              this.addObj = {
                name: "",
                code: "",
                desc: "",
                state: 0,
                grade: "",
              };
            })
            .catch((res) => {
              this.addLoading = false;
              //console.log("新增失败", res);
            });
        } else {
          Message.error("请完善表单信息");
          return false;
        }
      });
    },
    closeAdd() {
      this.$refs.addForm.resetFields();
      this.showAddWindow = false;
    },
    closeEdit() {
      this.$refs.editForm.resetFields();
      this.showEditWindow = false;
    },
    doCloseAdd(done) {
      this.$refs.addForm.resetFields();
      done();
    },
    doCloseEdit(done) {
      this.$refs.editForm.resetFields();
      done();
    },
    detail(row) {
      this.checkObj = row;
      this.showCheckWindow = true;
    },
    allotRole(row) {
      //console.log("角色对象", row);
      this.getMenuList(
        { pageNum: 1, pageSize: 10 },
        { menuId: "3d072a61118b461c9028e2546959ada9" }
      );
      this.currentRoleId = row.id;
      this.getRoleMenu(row.id);
      this.showAllotWindow = true;
    },
    onSaveAllot() {
      //console.log("当前选中树", this.$refs.alotTree.getCheckedKeys());
      this.$axios
        .post("/system/role/defineUserOwnsMenu", {
          roleId: this.currentRoleId,
          menuIds: this.$refs.alotTree.getCheckedKeys(),
        })
        .then((res) => {
          //console.log("权限修改结果", res);
          this.onReset();
          this.$refs.alotTree.setCheckedKeys([]);
          this.showAllotWindow = false;
        })
        .catch((res) => {
          //console.log("权限修改失败", res);
          this.showAllotWindow = false;
        });
    },
    closeAllot() {
      this.$refs.alotTree.setCheckedKeys([]);
      this.showAllotWindow = false;
    },
    doCloseAllot(done) {
      this.$refs.alotTree.setCheckedKeys([]);
      done();
    },
    editRole(row) {
      this.editObj = JSON.parse(JSON.stringify(row));
      this.showEditWindow = true;
    },
    sureEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.$axios
            .put("/system/role/updateRoleIfo", this.editObj)
            .then((res) => {
              Message.success("修改成功");
              this.editLoading = false;
              this.showEditWindow = false;
              this.onReset();

              //console.log("编辑成功", res);
            })
            .catch((res) => {
              this.editLoading = false;
              //console.log("编辑错误", res);
            });
        } else {
          Message.error("请完善表单信息");
          return false;
        }
      });
    },
    deleteRole(id) {
      this.deleteId = id;
      this.showDeleteWindow = true;
    },
    sureDelete() {
      this.$axios
        .delete(`/system/role/deleteRoleIfo/${this.deleteId}`)
        .then(() => {
          Message.success("删除成功");
          this.deleteId = "";
          this.showDeleteWindow = false;
          this.onReset();
        })
        .catch((res) => {
          //console.log("删除失败", res);
          this.deleteId = "";
          this.showDeleteWindow = false;
        });
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(current) {
      this.getRoleList({ pageNum: current, pageSize: 10 }, this.pageObj);
    },
    handleCurrentChangeMenu(current) {
      this.getMenuList({ pageNum: current, pageSize: 10 }, this.menuPageObj);
    },
    handleNodeClick(data, node) {
      //console.log("当前选中树的节点", node.key);
      this.getMenuList({ pageNum: 1, pageSize: 10 }, { menuId: node.key });
    },
    //获取菜单树
    getMenuTree() {
      this.menuTreeLoading = true;
      this.$axios
        .get("/system/menu/searchMenuTree", { params: "" })
        .then((res) => {
          //console.log("菜单树结果", res);
          this.menuTree = res.data;
          this.menuTreeLoading = false;
        })
        .catch((res) => {
          //console.log("菜单树获取失败", res);
          this.menuTreeLoading = false;
        });
    },
    //获取当前角色拥有菜单id
    getRoleMenu(roleId) {
      this.menuTreeLoading = true;
      this.$axios
        .get(`/system/role/searchUserOwnsMenu/${roleId}`)
        .then((res) => {
          //console.log("拥有结果", res);
          this.$refs.alotTree.setCheckedKeys(res.data);
          this.menuTreeLoading = false;
        })
        .catch((res) => {
          //console.log("拥有结果获取失败", res);
          this.menuTreeLoading = false;
        });
    },
    //获取菜单列表
    getMenuList(pms, searchObj) {
      this.loading = true;
      var pmsObj = Object.assign(pms, searchObj);
      this.$axios
        .get("/system/menu/searchMenuPageList", {
          params: pmsObj,
        })
        .then((res) => {
          this.loading = false;
          this.roleallotList = res.data;
          this.menuPageObj = searchObj;
          this.menuNum = res.total;
          //console.log("菜单列表结果", res);
        })
        .catch((res) => {
          this.loading = false;
          //console.log("菜单列表错误信息", res);
        });
    },
    //获取角色列表
    getRoleList(pms, searchObj) {
      this.loading = true;
      var pmsObj = Object.assign(pms, searchObj);
      this.$axios
        .get("/system/role/searchRolePageList", {
          params: pmsObj,
        })
        .then((res) => {
          this.loading = false;
          this.roleList = res.data;
          this.totalNum = res.total;
          this.pageObj = searchObj;
          //console.log("角色列表结果", res);
        })
        .catch((res) => {
          this.loading = false;
          //console.log("角色列表错误信息", res);
        });
    },
  },
  created() {
    this.onReset();
    this.getMenuTree();
    this.getMenuList(
      { pageNum: 1, pageSize: 10 },
      { menuId: "3d072a61118b461c9028e2546959ada9" }
    );
  },
};
</script>

<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.contentPadding42 {
  padding: 20px !important;
  box-shadow: 0px 0px 50px #ccc;
}
.content {
  display: flex;
  height: 100%;
  .left {
    width: 260px;

    padding: 16px 0;
    height: 100%;
    overflow: scroll;
  }
  .right {
    flex: 1;
  }
}
#ManageTable /deep/ .el-tree-node__children {
  .el-tree-node__label {
    padding: 2px 4px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }
  .el-tree-node:focus > .el-tree-node__content {
    background-color: #fff;
    .el-tree-node__label {
      background-color: #5584ff;
      color: #fff;
      box-shadow: 0px 2px 4px 0px #5584ff;
    }
  }
}
</style>